export class AttachmentChanged {
  constructor(id, name, isUploaded) {
    this.id = id;
    this.name = name;
    this.isUploaded = isUploaded;
  }
}
